<template>
    <div>
        <board-list-component v-if="boardType != ''" :boardType="`${boardType}Search`" :searchData="searchData" :boardName="boardType"></board-list-component>
    </div>
</template>

<script>
    // @ is an alias to /src

    import BoardListComponent from "@/components/board/BoardListComponent";
    import EventBus from "@/utils/event-bus";

    export default {
        name: 'Search',
        mixins: [],
        components: {BoardListComponent},
        props: {},
        data() {
            return {
                boardType: 'business',
                searchData: '',
                defaultFilter: {},
            }
        },
        beforeRouterEnter() {
        },
        created() {
            // this.searchBoard()
            this.boardType = this.$route.params.type
            this.searchData = this.$route.query.su
        },
        mounted() {
            EventBus.$on('setSearchData', this.searchBoard)
        },
        beforeDestroy() {
            EventBus.$off('setSearchData')
        },
        destroyed() {
        },
        computed: {},
        methods: {
            searchBoard() {
                this.boardType = '';
                this.$nextTick(() => {
                    this.boardType = this.$route.params.type;
                    this.searchData = this.$route.query.su
                })
            },
        },
        watch: {
            /*'$route.fullPath': {
                deep: true,
                handler: function () {
                    this.searchBoard()
                }
            },*/
        }
    }
</script>
